import { render, staticRenderFns } from "./SupplierBaseRequirementForm.vue?vue&type=template&id=62d96968"
import script from "./SupplierBaseRequirementForm.vue?vue&type=script&lang=js"
export * from "./SupplierBaseRequirementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports